import { Box } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import useClients from "hooks/useClients";
import EarningsForm from "./EarningsForm";

export function EarningsCreditNew() {
  const { client } = useClients();
  return (
    <Box>
      <Breadcrumbs
        data={[
          { label: "Finance", to: "/finance/pickups" },
          { label: "Clients", to: "/finance/clients" },
          { label: client ? client?.name : "", to: `/finance/clients/${client?.uuid}` },
          { label: "Add Credit" },
        ]}
      ></Breadcrumbs>
      <Box mt={4}>
        <EarningsForm clientName={client?.name} type={"::EarningsCredit"} />
      </Box>
    </Box>
  );
}
